import { createFileRoute } from '@tanstack/react-router'
import { ReportProfiles } from '@/features/report-profiles'

export const Route = createFileRoute(
  '/_authenticated/settings/report-profiles'
)({
  component: ReportProfiles,
})
